<template>
    <section class="software-installation">
        <help></help>
        <div class="panel">
            <div class="panel-heading">
                <h2>Software Installation Instructions (SII)<i class="clippie fa fa-info-circle" v-tooltip="'Follow these instructions to install your required software per term'"></i></h2>
            </div>
            <div class="panel-body">
                <div class="software-panel" v-if="isInPaths('9200') || isAdmin">
                    <h3>Houdini Program Software</h3>
                    <div class="row">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/houdini.jpg">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page', params: { slug: 'houdini' }, query: {software_page: true} }" class="btn btn-success software-button">
                                Install Houdini
                            </router-link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/autodesk.jpg?v=2.1">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page', params: { slug: 'autodesk' }, query: {software_page: true} }" class="btn btn-success software-button">
                                Autodesk Education Account
                            </router-link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/maya.jpg">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page', params: { slug: 'maya' }, query: {software_page: true} }" class="btn btn-success software-button">
                                Install Maya
                            </router-link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/arnold.jpg">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page', params: { slug: 'arnold' }, query: {software_page: true} }" class="btn btn-success software-button">
                                Install Arnold for Houdini
                            </router-link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/mari.jpg">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page', params: { slug: 'mari' }, query: {software_page: true} }" class="btn btn-success software-button">
                                Install Mari (T1)
                            </router-link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/nuke.jpg">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page', params: { slug: 'nuke-houdini' }, query: {software_page: true} }" class="btn btn-success software-button">
                                Install Nuke
                            </router-link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/substance-painter.jpg">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page',
                              params: { slug: 'substancepainter' },
                              query: {software_page: true} }" class="btn btn-success software-button">
                                Install Substance Painter
                            </router-link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/photoshop.jpg">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page', params: { slug: 'photoshop' }, query: {software_page: true} }" class="btn btn-success software-button">
                                Install Photoshop
                            </router-link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/substance-designer.jpg">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page',
                              params: { slug: 'substancedesigner' },
                              query: {software_page: true} }" class="btn btn-success software-button">
                                Install Substance Designer (T2, T3, T4)
                            </router-link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/unreal.png">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page',
                              params: { slug: 'unreal' },
                              query: {software_page: true} }" class="btn btn-success software-button">
                                Install Unreal Engine (T2, T3, T4)
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="software-panel" v-if="!isInPaths('9200') || isAdmin">
                    <h3>Fundamentals Term</h3>
                    <div class="row">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/autodesk.jpg?v=2.1">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page', params: { slug: 'autodesk' }, query: {software_page: true} }" class="btn btn-success software-button">
                                Autodesk Education Account
                            </router-link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/winrar.jpg">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page', params: { slug: 'winrar' }, query: {software_page: true} }" class="btn btn-success software-button">
                                Install WinRAR
                            </router-link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/zoom.jpg">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page', params: { slug: 'zoom' }, query: {software_page: true} }" class="btn btn-success software-button">
                                Install Zoom
                            </router-link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/mari.jpg">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page', params: { slug: 'mari' }, query: {software_page: true} }" class="btn btn-success software-button">
                                Install Mari
                            </router-link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/nuke.jpg">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page',
                              params: { slug: 'nuke' },
                              query: {software_page: true} }" class="btn btn-success software-button">
                                Install Nuke
                            </router-link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/maya.jpg?v=2.1">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page', params: { slug: 'maya' }, query: {software_page: true} }" class="btn btn-success software-button">
                                Install Maya
                            </router-link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/v-ray.jpg">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page', params: { slug: 'v-ray' , query: {software_page: true}} }" class="btn btn-success software-button">
                                Install V-Ray
                            </router-link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/photoshop.jpg">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page', params: { slug: 'photoshop' }, query: {software_page: true} }" class="btn btn-success software-button">
                                Install Photoshop
                            </router-link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/substance-painter.jpg">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page',
                              params: { slug: 'substancepainter' },
                              query: {software_page: true} }" class="btn btn-success software-button">
                                Install Substance Painter
                            </router-link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/zbrush.png">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page',
                              params: { slug: 'zbrush' },
                              query: {software_page: true} }" class="btn btn-success software-button">
                                Install ZBrush
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="software-panel" v-if="isAdmin || !isInPaths('9200')" :class="{'disabled': disabled }">
                    <h3>Intermediate, Advanced, Portfolio Production Terms</h3>
                    
                    <div class="row" v-if="isAdmin || isInPaths('6627,6643,9130,9131')">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/unreal.png">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page',
                              params: { slug: 'unreal' },
                              query: {software_page: true} }" class="btn btn-success software-button">
                                Install Unreal Engine
                            </router-link>
                        </div>
                    </div>
                   
                    <div class="row" v-if="isAdmin || isInPaths('6627,6643,6644,9131,9130')">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/substance-designer.jpg">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page',
                              params: { slug: 'substancedesigner' },
                              query: {software_page: true} }" class="btn btn-success software-button">
                                Install Substance Designer
                            </router-link>
                        </div>
                    </div>
                    <div class="row" v-if="isAdmin || isInPaths('6627,6643')">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/marmoset.jpg">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page',
                              params: { slug: 'marmoset' },
                              query: {software_page: true} }" class="btn btn-success software-button">
                                Install Marmoset
                            </router-link>
                        </div>
                    </div>
                    <div class="row" v-if="isAdmin || isInPaths('9130')">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/marmoset.jpg">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page',
                              params: { slug: 'marmoset' },
                              query: {software_page: true} }" class="btn btn-success software-button">
                                Install Marmoset (T2)
                            </router-link>
                        </div>                       
                    </div>                     

                    <div class="row" v-if="isAdmin || isInPaths('6642,6644,9131,9130,6627')">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/agisoft-photoscan.jpg">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page',
                              params: { slug: 'agisoft' },
                              query: {software_page: true} }" class="btn btn-success software-button">
                                Install Agisoft Photoscan
                            </router-link>
                        </div>
                    </div>
                    <div class="row" v-if="isAdmin || isInPaths('6642,6644,9131,9130')">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/nuke.jpg">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page',
                              params: { slug: 'nuke' },
                              query: {software_page: true} }" class="btn btn-success software-button">
                                Install Nuke
                            </router-link>
                        </div>
                    </div>
                    <div class="row" v-if="isAdmin || isInPaths('6627,6642,6643,6644,9131,9130')">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/marvelous-designer.jpg">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page',
                              params: { slug: 'marvelous' },
                              query: {software_page: true} }" class="btn btn-success software-button">
                                Install Marvelous Designer
                            </router-link>
                        </div>
                    </div>
                    <div class="row" v-if="isAdmin || isInPaths('9131,6627')">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/gaea.jpg">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page',
                              params: { slug: 'gaea' },
                              query: {software_page: true} }" class="btn btn-success software-button">
                                Install Gaea 2.0 (T2)
                            </router-link>
                        </div>
                    </div>
                    <div class="row" v-if="isAdmin || isInPaths('9130,6643')">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/wrap.jpg">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page',
                              params: { slug: 'wrap' },
                              query: {software_page: true} }" class="btn btn-success software-button">
                                Install Wrap
                            </router-link>
                        </div>
                    </div>
                    <div class="row" v-if="isAdmin || isInPaths('9131')">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/houdini.jpg">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page', params: { slug: 'houdini' }, query: {software_page: true} }" class="btn btn-success software-button">
                                Install Houdini (T3 + T4)
                            </router-link>
                        </div>
                    </div>
                    <div class="row" v-if="isAdmin || isInPaths('6627')">
                        <div class="col-sm-4">
                            <img class="software-image" src="../assets/img/software/speedtree.png">
                        </div>
                        <div class="col-sm-6">
                            <router-link :to="{ name: 'help-page', params: { slug: 'speedtree' }, query: {software_page: true} }" class="btn btn-success software-button">
                                Install SpeedTree
                            </router-link>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import help from './widgets/Help.vue';

import moment from 'moment';

// ignore this part

export default {
    data() {
        return {

        }
    },
    components: { help },
    methods: {

        isInPaths(paths) {
            return paths.indexOf(localStorage.path) > -1;
        }
    },
    computed: {
        isAdmin() {
            return JSON.parse(localStorage.roles).includes('Admin') ||
                JSON.parse(localStorage.roles).includes('CourseAdmin');
        },
        disabled() {
            if (!this.$store.getters.currentTerm) return;

            let userTerms = localStorage.terms.split(',');
            if (userTerms.length === 1) {
                if (localStorage.intermediateTermStartDate && localStorage.intermediateTermStartDate != 'undefined' && localStorage.intermediateTermStartDate != '' && localStorage.intermediateTermStartDate != 'null') {
                    let intermediateTermStartDate = new Date(localStorage.intermediateTermStartDate);
                    let diff = moment(intermediateTermStartDate).diff(moment(), 'days');
                    if (diff < 14) return false;
                }
            }
            if (userTerms.length > 1) {
                return false;
            }
            return true;
        }
    }
}

</script>
<style lang="scss" scoped>
// and CSS here

.software-image {
    width: 67px;
    height: 67px;
    object-fit: cover;
}

.panel-body {
    padding: 20px !important;
}

h3 {
    font-weight: 100;
    margin-bottom: 30px
}

.software-panel {
    border: solid 1px #363636;
    margin-bottom: 30px;
    background-color: #222222;
    padding: 0 15px 40px 15px;
    box-shadow: 0px 0px 30px black;

    &.disabled {
        opacity: .5;

        .software-button {
            cursor: default;
            pointer-events: none;
        }

    }

}

.software-button {
    //margin-top: 5px;
    min-width: 300px;
    background-color: #363636;
    color: white;
    border-color: #666 !important;
}

.btn-success:hover {
    border-color: #ccc !important;
}

.row {
    clear: both;
    display: block;
    margin-bottom: 20px;
    border-bottom: solid 1px #363636;
}

.term-2 {
    opacity: .5;
}

.term-3 {
    opacity: .3;
}

.disable-link {
    pointer-events: none;
    cursor: default;
}

</style>



// WEBPACK FOOTER //
// SoftwareInstallation.vue?39d80e12